export const pushToDataLayer = payload => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(payload);
    if (process.env.NODE_ENV === 'development') {
      console.log('GTM Event Fired:', payload);
    }
  }
};

export const hashEmail = async email => {
  if (!email) return '';
  const normalizedEmail = email.toLowerCase().trim();
  const encoder = new TextEncoder();
  const data = encoder.encode(normalizedEmail);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
